var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAffiliate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-16.569-13.432-30-30-30-16.568 0-30 13.431-30 30 0 16.569 13.432 30 30 30C-13.432 30 0 16.569 0 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(286 467)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-33.137 0-60-27.862-60-61H60C60-27.862 33.137 0 0 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(256 407)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-16.569-13.432-30-30-30-16.568 0-30 13.431-30 30 0 16.569 13.432 30 30 30C-13.432 30 0 16.569 0 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(466 286)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-33.137 0-60-26.862-60-60H61C61-26.862 33.137 0 0 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(436 226)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-16.569-13.432-30-30-30-16.568 0-30 13.431-30 30 0 16.569 13.432 30 30 30C-13.432 30 0 16.569 0 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(106 286)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-33.137 0-61-26.862-61-60H60C60-26.862 33.137 0 0 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(76 226)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-16.569-13.432-30-30-30-16.568 0-30 13.431-30 30 0 16.569 13.432 30 30 30C-13.432 30 0 16.569 0 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(286 136)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-33.137 0-60-26.862-60-60H60C60-26.862 33.137 0 0 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(256 75)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 33.137 26.863 61 60 61",
    style: {
      strokeWidth: 30,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(76 376)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 33.137-26.863 61-60 61",
    style: {
      strokeWidth: 30,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(436 376)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-33.137 26.863-61 60-61",
    style: {
      strokeWidth: 30,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(76 106)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-33.137-26.863-61-60-61",
    style: {
      strokeWidth: 30,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(436 106)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliate);
export default __webpack_public_path__ + "static/media/affiliate.a400de64efc7b0164f96b51d74b67ed9.svg";
export { ForwardRef as ReactComponent };